module.exports = __webpack_public_path__ + "img/works_tiger_e_btm.bf5d43c8.jpg";